"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* eslint-disable no-console */
const syncRequest = ({
  url,
  type = 'GET',
  options = {},
  fallback
}) => {
  let response;
  try {
    let xhr;
    if (typeof window !== 'undefined') {
      // eslint-disable-next-line no-undef
      xhr = new XMLHttpRequest();
    } else {
      try {
        const XMLHttpRequest = require('xmlhttprequest').XMLHttpRequest;
        xhr = new XMLHttpRequest();
      } catch (e) {
        console.error('XMLHttpRequest polyfill is having issues', e);
      }
    }
    if (url) {
      xhr.open(type, url, false);
      xhr.send();
      if (xhr.status === 200) {
        response = JSON.parse(xhr.responseText);
      } else {
        throw new Error(`XMLHttpRequest failed to fetch ${url}`);
      }
    } else {
      response = require(fallback);
      console.log('🚀 ~ file: syncRequest.js:25 ~ syncRequest ~ URL was empty:');
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`Error: Exception occurred in fetching ${url} and hence using the fallback`, e);
    if (fallback) {
      try {
        response = require(fallback);
      } catch {
        console.error(`Error occurred in loading fallback ${fallback}. This is happening in pod console then it is a high priority.`);
      }
    }
  }
  return response;
};
var _default = exports.default = syncRequest;